// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advancespg-inline-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.advancespg-inline-2 {
  margin-bottom: 0;
}

.advancespg-inline-3 {
  padding: 0;
  overflow-x: auto;
}

.advancespg-inline-4 {
  font-family: monospace;
  font-size: 11px;
}

.advancespg-inline-5 {
  font-weight: 600;
}

.advancespg-inline-6 {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.advancespg-inline-7 {
  font-size: 10px;
  padding: 3px 8px;
}

.advancespg-inline-8 {
  font-size: 10px;
  padding: 3px 8px;
}

.advancespg-inline-9 {
  font-size: 10px;
  padding: 3px 8px;
}

.advancespg-inline-10 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}

.advancespg-dyn-1 {
  text-align: center;
  padding: 40px;
  color: var(--advancespg-1-color);
}

.advancespg-dyn-2 {
  font-size: 10px;
  color: var(--advancespg-2-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/AdvancesPg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC","sourcesContent":[".advancespg-inline-1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.advancespg-inline-2 {\n  margin-bottom: 0;\n}\n\n.advancespg-inline-3 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.advancespg-inline-4 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.advancespg-inline-5 {\n  font-weight: 600;\n}\n\n.advancespg-inline-6 {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.advancespg-inline-7 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.advancespg-inline-8 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.advancespg-inline-9 {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n.advancespg-inline-10 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n.advancespg-dyn-1 {\n  text-align: center;\n  padding: 40px;\n  color: var(--advancespg-1-color);\n}\n\n.advancespg-dyn-2 {\n  font-size: 10px;\n  color: var(--advancespg-2-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
